import { Settings, Zap, Droplets, HardHat, ShieldCheck, Users } from "lucide-react";
export default function ServicesMiningEquipment() {
  const services = [{
    title: "Core Mining Equipment",
    description: "Underground mining machinery, crushers, and vibrating feeders designed for durability.",
    icon: HardHat,
    image: {
      src: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_1863556472-scaled.jpeg?v=5mv7lnk6t1q",
      srcset: "https://theleads.co.za/wp-content/uploads/2026/06/mwr_preview_7cb35756fb-2.webp?v=sxmht2y3kmp-wvc-srcset",
      sizes: "https://theleads.co.za/wp-content/uploads/2026/06/mwr_preview_7cb35756fb-2.webp?v=rio1mwqa1c9-wvc-sizes",
      alt: "Underground mining machinery"
    }
  }, {
    title: "Pumping Systems",
    description: "High-capacity pumping systems and industrial piping for efficient fluid management.",
    icon: Droplets,
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/industrial_pumping_equipment.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/industrial_pumping_equipment.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/industrial_pumping_equipment.png-wvc-sizes",
      alt: "Industrial pumping equipment"
    }
  }, {
    title: "Electrical Solutions",
    description: "Switchboards, electrical components, and specialized LED lighting systems.",
    icon: Zap,
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_electrical_systems.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_electrical_systems.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_electrical_systems.png-wvc-sizes",
      alt: "Mining electrical systems"
    }
  }, {
    title: "Operational Supplies",
    description: "Welding machines, consumables, protective coatings, and demarcation lights.",
    icon: Settings,
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_operational_supplies.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_operational_supplies.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_operational_supplies.webp-wvc-sizes",
      alt: "Mining operational supplies"
    }
  }, {
    title: "Support Services",
    description: "Expert consulting, routine maintenance, and dedicated on-site technician training.",
    icon: Users,
    image: {
      src: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_652906248-scaled.jpeg?v=duwtxys5lrb",
      srcset: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_652906248-scaled.jpeg?v=us54z237uxm-wvc-srcset",
      sizes: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_652906248-scaled.jpeg?v=b7masu5y9ke-wvc-sizes",
      alt: "Mining support technicians"
    }
  }, {
    title: "Safety & Protection",
    description: "Comprehensive safety equipment and protective solutions for mining personnel.",
    icon: ShieldCheck,
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_safety_equipment.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_safety_equipment.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_safety_equipment.png-wvc-sizes",
      alt: "Mining safety equipment"
    }
  }];
  return <section className="bg-background ![padding:5px_0px_40px_0px]">
      <div className="page-container">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6 tracking-tight">
            SERVICES & MINING EQUIPMENT
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mb-8 rounded-lg" />
          <p className="leading-relaxed !font-sans !text-[rgba(0,70,84,1)] !font-medium !text-sm">THE LEADS OFFERS A COMPREHENSIVE RANGE OF SPECIALISED SERVICES, TOOLS, AND EQUIPMENT DEDICATED TO SUPPORTING DIVERSE MINING FACILITIES AND OPERATIONS. FROM HEAVY MACHINERY TO ESSENTIAL PARTS AND EVERYDAY SUPPLIES, WE FOCUS ON OUTFITTING YOUR FACILITY WITH THE KEY COMPONENTS REQUIRED FOR SMOOTH, DAILY OPERATIONS.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => <div key={i} data-index={i} className="group relative overflow-hidden rounded-lg shadow-md bg-card transition-all duration-300 hover:shadow-xl border border-border">
              <div className="aspect-video overflow-hidden">
                <img src={service.image.src} data-wvc-srcset={service.image.srcset} data-wvc-sizes={service.image.sizes} alt={service.image.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" />
                <div className="absolute inset-0 bg-primary/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <service.icon className="w-12 h-12 text-white" />
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="p-2 rounded-md bg-primary/10 text-primary">
                    <service.icon className="w-5 h-5" />
                  </div>
                  <h3 className="text-xl font-bold text-foreground">{service.title}</h3>
                </div>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>)}
        </div>

        
      </div>
    </section>;
}